import { useState } from "react";
import moment from "moment";

const oneMonth = 2592000;
const lsPromptName = "webInstallPromptedA";

const setInstallPromptSeenToday = (): void => {
  const today = moment().unix();
  localStorage.setItem(lsPromptName, today.toString());
};

const getUserShouldBePromptedToInstall = () => {
  const lastPrompt = localStorage.getItem(lsPromptName);
  if (!lastPrompt) {
    return true;
  }
  const now = moment().unix();
  const shouldShow = now - oneMonth > parseInt(lastPrompt);
  return shouldShow;
};

export const useShouldShowPrompt = (): [boolean, () => void] => {
  const [userShouldBePromptedToInstall, setUserShouldBePromptedToInstall] =
    useState(getUserShouldBePromptedToInstall());

  const handleUserSeeingInstallPrompt = () => {
    setUserShouldBePromptedToInstall(false);
    setInstallPromptSeenToday();
  };

  return [userShouldBePromptedToInstall, handleUserSeeingInstallPrompt];
};
